import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';
import { Subtitle3 } from 'elc-typography';

export const SingleShadeWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 ${ContentSpacing.space32};
`;

export const SingleShadeName = styled(Subtitle3)`
    margin: 0 ${ContentSpacing.space8};
`;
